<template>
  <div class="container py-4">
    <div class="position-relative d-flex">
      <a class="btn wfh-btn-link-primary font-weight-bold position-absolute" href="/dashboard">
        <BackIcon/> Back To Dashboard
      </a>

      <div class="d-flex flex-column w-100 justify-content-center">
        <div class="row">
          <div class="col-auto mx-auto">
            <h1 class="wfh-page-header">Advanced</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-auto mx-auto">
            <p class="wfh-page-description">Let's see how ready your team is to work from home.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8 mx-auto">
        <ul class="nav nav-pills nav-fill" role="tablist" v-if="showNavigation && !isExternalMember">
          <li class="nav-item nav-border-override" role="presentation">
            <a
                class="nav-link active"
                id="task-tab"
                data-toggle="pill"
                href="#task"
                role="tab"
                aria-controls="advanced"
                aria-selected="true"
                @click="activeTab = 1"
            >
              Task
            </a>
          </li>
          <li class="nav-item nav-border-override" role="presentation">
            <a
                class="nav-link"
                id="metrics-tab"
                data-toggle="pill"
                href="#metrics"
                role="tab"
                aria-controls="metrics"
                aria-selected="true"
                @click="activeTab = 2"
            >
              Metrics
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row py-4">
      <div class="col-12 col-md-8 mx-auto">
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active"
               id="task"
               role="tabpanel"
               aria-labelledby="task-tab"
               v-show="activeTab === 1"
               v-if="task_type !== 'metric' || !task_id"
          >
            <task-advance
                :task_id="task_id"
                :task_title="task_title"
                :task_type="task_type"
                :completed_at="completed_at"
                :company="user_company"
            ></task-advance>
          </div>


          <div class="tab-pane fade show active"
               id="metrics"
               role="tabpanel"
               aria-labelledby="metrics-tab"
               v-show="activeTab === 2"
               v-if="task_type === 'metric' || !task_id"
          >
            <task-metrics :user_company="user_company" :goal_id="task_id"></task-metrics>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackIcon from '../../../icons/BackIcon';
export default {
  components: { BackIcon },
  props: ['task_title', 'task_type', 'completed_at', 'task_id'],

  data () {
    return {
      activeTab: this.task_type === 'metric' ? 2 : 1,
      user_company: null,
    };
  },

  computed: {
    showNavigation () {
      return !this.task_id && this.task_type !== 'hourly';
    },

    isExternalMember () {
      return this.$store.state.isExternal;
    },
  },

  methods: {
    async getUserCompany () {
      const res = await axios.get('/get-user-company');
      this.user_company = res.data.data;
    },
  },

  mounted () {
    this.getUserCompany();
  },
};
</script>
